document.addEventListener("alpine:init", () => {
  Alpine.data("progressBarContainer", () => ({
    scrollContainer: null,
    scrollBar: null,
    pageHeader: null,
    subNav: null,
    chapterSection: null,
    screenWidth: window.innerWidth,
    subNavOffset: null,
    headerOffset: null,
    init() {
      this.scrollContainer = this.$el;
      this.scrollBar = this.$refs.progressBar;
      this.pageHeader = document.querySelector(".Navigation__bar");
      this.subNav = document.querySelector(".Sub__Nav__bar");
      this.chapterSection = document.querySelector("#report-chapters__mobile");

      this.headerOffset = this.pageHeader.offsetHeight * 2;
      if (this.subNav) {
        this.subNavOffset = this.subNav.offsetHeight;
      }

      this.updateProgressBar();

      if (this.pageHeader && !this.subNav) {
        this.placeUnderHeader();
      }

      if (this.pageHeader && this.subNav && !this.chapterSection) {
        this.placeUnderSubNav();
      }

      if (
        this.chapterSection &&
        this.screenWidth < 767.99 &&
        this.pageHeader &&
        !this.subNav
      ) {
        this.placeUnderChapters();
      }

      window.addEventListener("scroll", () => this.handleScroll());
    },

    handleScroll() {
      const scrollPosition = window.scrollY + window.innerHeight;
      const subNavScrollOffset = this.subNavOffset * 3 + window.innerHeight;

      if (!this.subNav) {
        if (scrollPosition >= this.headerOffset) {
          this.scrollContainer.style.opacity = 1;
        } else {
          this.scrollContainer.style.opacity = 0;
        }
      } else if (this.subNav) {
        if (scrollPosition >= subNavScrollOffset) {
          this.scrollContainer.style.opacity = 1;
        } else {
          this.scrollContainer.style.opacity = 0;
        }
      }
    },
    scrollPercent() {
      return (
        (window.scrollY / (document.body.scrollHeight - window.innerHeight)) *
        100
      );
    },
    updateProgressBar() {
      if (!this.scrollBar) return;
      this.scrollBar.style.width = this.scrollPercent() + "%";
      requestAnimationFrame(() => this.updateProgressBar());
    },
    placeUnderHeader() {
      this.pageHeader.insertAdjacentElement("afterend", this.scrollContainer);
    },
    placeUnderSubNav() {
      this.scrollContainer.style.position = "fixed";

      if (this.screenWidth < 767.99) {
        this.scrollContainer.style.top = 70 + "px";
      } else {
        this.scrollContainer.style.top = this.subNavOffset + "px";
      }

      this.subNav.insertAdjacentElement("beforeend", this.scrollContainer);
    },
    placeUnderChapters() {
      this.chapterSection.insertAdjacentElement(
        "beforeend",
        this.scrollContainer
      );
    },
  }));
});
